import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useHospiceConvertToPending } from "../../../store/useHospiceConvertToPending";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import CommentInput from "../../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    computed: {
        ...mapState(useHospiceConvertToPending, ["patientDetails", "application"])
    },
    methods: {
        addNewCommentAppend(newValue: any) {
            this.patientDetails.faceSheetComments = this.patientDetails.faceSheetComments.concat(newValue);
        },
        commentUpdated(value: string) {
            this.patientDetails.faceSheetComments = value;
        }
    }
});
